import get from 'lodash.get';
import getVariables from './variables';

const getVariableValueByPath = (state, pathToValue) => {
  const variables = getVariables(state);

  return get(variables, pathToValue);
};

export default getVariableValueByPath;
